import { IAppState } from 'models/store.model'
import { IUserStatus } from 'models/user.model'
import { LoginMethod } from 'root-constants'

export const selectUUID = (state: IAppState): string => state.user.uuid
export const selectUserStatus = (state: IAppState): IUserStatus | null =>
  state.user.status
export const selectUserAccountLoginMethod = (
  state: IAppState,
): LoginMethod | null => state.user.status?.account?.loginMethod || null
export const selectTestEnvironmentQueryParam = (state: IAppState): string =>
  state.user.testEnvironmentQueryParam
export const selectUserCountryCode = (state: IAppState): string =>
  state.user.status?.countryCode || ''
export const selectLanguage = (state: IAppState): string =>
  state.common.language
